<template>
    <button class="button-whatsapp" @click="redirectWhatsapp()">
        <img src="https://res.cloudinary.com/dyikvzcke/image/upload/v1755472002/unnamed_l1h8vc.webp" alt="whatsapp" />
    </button>
</template>

<script setup>
function redirectWhatsapp() {
    window.open('https://api.whatsapp.com/send?phone=51998247832', '_blank', 'noopener,noreferrer');
}
</script>

<style lang="scss" scoped>
.button-whatsapp {
    position: fixed;
    bottom: 20px;
    right: 20px;
    width: 70px;
    height: 70px;
    border-radius: 50%;
    background-color: #25d366;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.3s ease;
    border: none;
    z-index: 1000;
    img {
        width: 45px;
        height: 45px;
    }

    &:hover {
        background-color: #1ebe5d;
    }
}
</style>